import * as React from 'react';
import ModuleSidebar from './ModuleSidebar';

class ModulesHome extends React.Component {
  constructor() {
    // state
    super();
    this.state = {};
  }

  componentDidMount() {
    document.title = 'TrinDocs - Modules'
  }
  componentWillUnmount() {}
  componentDidUpdate() {}

  render() {
    return (
      <div className='sidebarLayout d-flex flex-row flex-fill'>
        <div className='sidebar-container'>{<ModuleSidebar />}</div>
        <div className='flex-fill'>
          <div className='h-100 d-flex flex-column align-items-center justify-content-center'>
            <i className='fa-solid fa-box' size='6x' />
            <h2
              style={{
                fontWeight: 'bolder',
                fontStyle: 'italic',
                margin: '16px',
              }}
            >
              Modules
            </h2>
          </div>
        </div>
      </div>
    );
  }
}

export default ModulesHome;
